import * as React from 'react'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'
import { IAppState } from '../../redux/reducers'


const sampleManualSectionsObj = [
    {
        id: 25,
        blurb: 'A general view of all procedures.',
        sectionTitle: 'General'
    },
    {
        id: 28,
        blurb: 'How to load the vehicles.',
        sectionTitle: 'Loading'
    },
    {
        id: 32,
        blurb: 'Packing',
        sectionTitle: 'Packing'
    }
]

interface ManualProps {

}

const Manual : React.FunctionComponent<ManualProps> = ({}) : JSX.Element => {
    let auth = useSelector((state:IAppState) => state.auth)
    const userRole = auth && auth.userData &&  _.isArray(auth.userData.roles) && auth.userData.roles[0]

    const renderManualTitles = () : any => {
        let titleArr  = []
        for(let i=0; i<sampleManualSectionsObj.length; ++i) {
            titleArr.push(
                <div key={i}>
                    <h5>{sampleManualSectionsObj[i].sectionTitle}</h5>
                    <p>{sampleManualSectionsObj[i].blurb}</p>
                </div>
            )
        }
        return titleArr
    }

    return (
        <div>
            <h3>Manual</h3>
            {renderManualTitles()}
        </div>
    )
}

export default Manual